import { render, staticRenderFns } from "./ConnectOrLatencyAlert.vue?vue&type=template&id=26c1f842"
import script from "./ConnectOrLatencyAlert.vue?vue&type=script&lang=js"
export * from "./ConnectOrLatencyAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports